export enum BlobContainer {
  chapterImageContainer = 'chapter-images',
  proposedRuleImageContainer = 'proposed-rule-images',
  historicalChapterPdfContainer = 'historical-chapter-pdfs'
}
